var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"background"},_vm._l((_vm.sparkles),function(sparkle){return _c('div',{key:sparkle.index,style:(sparkle.style),attrs:{"id":'sprkl_'+sparkle.index}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }